// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3OBSf","info":"PatientInfo_info__2TKL6"};